angular.module('gym.data_series', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.data_series', {
    url: '/data_series',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.data_series.optIn', {
    url: '/settings/toggle',
    controller: 'DataSeriesOptInCtrl',
    template: require('templates/gyms/data_series/toggle.html.slim')
  });
}]);
